import { Link } from 'react-router-dom';
import styles from './About.module.css';

export default function About() {
  return (
    <div className={`container ${styles.page}`}>
      <h1 className={styles.title}>About ConcertFinder</h1>
      <div className={styles.body}>
        <p>
          ConcertFinder is a directory for local live music at bars and small venues — the kind of shows
          that don't have a marketing budget and don't show up on the big ticketing platforms.
        </p>
        <p>
          We focus on Denton, Texas and the surrounding area. Our data comes from scraping individual
          venue websites daily, so you get up-to-date listings without having to check each place separately.
        </p>
        <h2>How the data works</h2>
        <p>
          We check each venue's website once a day and extract upcoming shows automatically. When a venue
          doesn't have a structured calendar, we use AI to parse the page. Genre tags are inferred, not
          manually assigned — they're a best guess and may occasionally be wrong.
        </p>
        <h2>Missing a venue?</h2>
        <p>
          If you know a bar or small venue doing live music that we're not covering, <Link to="/suggest">suggest it here</Link>.
          We review all suggestions before adding them.
        </p>
      </div>
    </div>
  );
}
